import { Box, Button, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import { useState } from "react";
import EditCertificate from "./edit-certificate/edit-certificate";

type Props = {
  certificationType: string;
  certificate: any;
  inspectorFirmId: any;
  isFreddieMacExemptInspector: boolean;
  certificationMethods: any;
  isMyOrganisation?: boolean;
};

const FreddieMacCertificateDetailRow = ({
  certificationType,
  certificate,
  inspectorFirmId,
  isFreddieMacExemptInspector,
  certificationMethods,
  isMyOrganisation,
}: Props) => {
  const [showEditCertification, setShowEditCertification] = useState(false);

  const renderStatus = (status: string) => {
    const statusConfig: Record<
      string,
      { icon: JSX.Element; text: string; color: string }
    > = {
      Verified: {
        icon: <CheckCircleOutlineIcon color="success" />,
        text: "Verified",
        color: "success",
      },
      Pending: {
        icon: <PendingOutlinedIcon color="warning" />,
        text: "Pending Verification",
        color: "warning",
      },
      Incomplete: {
        icon: <WarningAmberIcon color="error" />,
        text: "Incomplete",
        color: "error",
      },
    };

    const config = statusConfig[status] || statusConfig["Incomplete"];

    return (
      <>
        {config.icon}
        <Typography color={config.color}>{config.text}</Typography>
      </>
    );
  };

  return (
    <>
      <Box className="user-name-layout">
        <Typography className="label-txt">{certificationType}</Typography>
        {certificate || isFreddieMacExemptInspector ? (
          <Box sx={{ display: "flex" }}>
            <Box sx={{ maxWidth: "226px" }}>
              <Typography className="label-header-text">
                Exempt Inspector
              </Typography>
              {isFreddieMacExemptInspector ? (
                <Box>
                  <CheckCircleOutlineIcon color="success" />
                </Box>
              ) : (
                <Typography>No</Typography>
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                maxWidth: "226px",
              }}
            >
              <Box>
                <Typography className="label-header-text">
                  Certified Inspector?
                </Typography>
                <Typography>
                  {certificate?.certificationMethod ? "Yes" : "No"}
                </Typography>
              </Box>
              <Box>
                <Typography className="label-header-text">
                  Freddie Mac Approved Training
                </Typography>
                <Typography>
                  {certificate?.certificationMethod
                    ? certificationMethods
                        ?.filter(
                          (method: { certificationMethod: any }) =>
                            method.certificationMethod ===
                            certificate?.certificationMethod
                        )
                        .map(
                          (method: { displayName: any }) => method.displayName
                        )
                    : "-"}
                </Typography>
              </Box>
              <Box>
                <Typography className="label-header-text">
                  Certificate
                </Typography>
                {certificate?.certificateFileName ? (
                  <Box>
                    <CheckCircleOutlineIcon color="success" />
                  </Box>
                ) : (
                  [
                    !isMyOrganisation && (
                      <Button
                        variant="text"
                        startIcon={<AddOutlinedIcon />}
                        onClick={() => {
                          setShowEditCertification(true);
                        }}
                      >
                        ADD
                      </Button>
                    ),
                  ]
                )}
              </Box>
            </Box>
            <Box>
              <Typography className="label-header-text">
                Declaration Doc
              </Typography>
              <Typography>
                {certificate?.declarationFileName ? (
                  <Box>
                    <CheckCircleOutlineIcon color="success" />
                  </Box>
                ) : (
                  [
                    !isMyOrganisation && (
                      <Typography color="primary">
                        <Button
                          variant="text"
                          startIcon={<AddOutlinedIcon />}
                          onClick={() => {
                            setShowEditCertification(true);
                          }}
                        >
                          ADD
                        </Button>
                      </Typography>
                    ),
                  ]
                )}
              </Typography>
            </Box>
            <Box>
              <Typography className="label-header-text">Status</Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {renderStatus(certificate?.status || "Incomplete")}
              </Box>
            </Box>
            <Box>
              <EditOutlinedIcon
                sx={{ cursor: "pointer", pt: "8px" }}
                color="primary"
                onClick={() => {
                  setShowEditCertification(true);
                }}
              />
            </Box>
          </Box>
        ) : (
          [
            !isMyOrganisation && (
              <Button
                variant="outlined"
                startIcon={<AddOutlinedIcon />}
                onClick={() => {
                  setShowEditCertification(true);
                }}
              >
                Add Certification
              </Button>
            ),
          ]
        )}
        {showEditCertification && (
          <EditCertificate
            showDialog={showEditCertification}
            closeDialog={() => {
              setShowEditCertification(false);
            }}
            data={{
              ...certificate,
              certificationType,
              id: inspectorFirmId,
              isFreddieMacExemptInspector,
            }}
          />
        )}
      </Box>
    </>
  );
};

export default FreddieMacCertificateDetailRow;
